@if (data && data.Id && data.Id > 0) {
  <app-search [showSearch]="showSearch" [data]="data"></app-search>
  @if (data.Locations && data.Locations.length > 0 && !showSearch) {
    <div class="locations">
      @for (location of data.Locations; track $index) {
        <a [routerLink]="['/' + location.Url]"
          >Hoteller i {{ location.Name }}</a
        >
      }
    </div>
  }

  @if (loadKayakIframe && kayakUrl && kayakUrl != "" && !showSearch) {
    <app-hotel-results [kayakUrl]="kayakUrl"></app-hotel-results>

    @if (data.Sections && data.Sections.length > 0) {
      <div id="sections">
        @for (section of data.Sections; track section) {
          <section
            class="{{
              section.Media == null || section.Media.length == 0 ? 'full' : ''
            }}"
          >
            @if (section.Media && section.Media.length > 0) {
              <div class="img-wrapper">
                @for (media of section.Media; track media) {
                  @if (media.Url) {
                    <img
                      [src]="media.Url | apiImage: 500 : media : 'fill'"
                      [alt]="data.Name"
                      loading="lazy"
                    />
                  }
                }
              </div>
            }
            <div class="section-text">
              <app-inner-html [html]="section.Description"></app-inner-html>
            </div>
          </section>
        }
      </div>
    }
  }
}
